"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGridExpandableRowRenderer = void 0;
const react_1 = __importDefault(require("react"));
const LoadingGridRow_1 = require("../loadingGridRow/LoadingGridRow");
function createGridExpandableRowRenderer(params) {
    return function RenderGridRow(_a) {
        var { className, originalRenderer } = _a, rest = __rest(_a, ["className", "originalRenderer"]);
        if (!originalRenderer) {
            throw new Error('GridCore error: "originalRenderer" must be provided ');
        }
        const { depth, isLoading } = params.getMetaByIndex(rest.index);
        const isOddRow = Boolean(depth % 2);
        if (isLoading) {
            return (react_1.default.createElement(LoadingGridRow_1.LoadingGridRow, { title: params.loadingRowTitle, style: Object.assign({ minWidth: rest.width, height: rest.height, top: `${rest.topOffset}px` }, rest.style), className: className }));
        }
        return originalRenderer(Object.assign(Object.assign({}, rest), { isOddRow,
            className }));
    };
}
exports.createGridExpandableRowRenderer = createGridExpandableRowRenderer;
//# sourceMappingURL=createGridExpandableRowRenderer.js.map